// extracted by mini-css-extract-plugin
module.exports = {"pageParent":"styles_pageParent__2dGQc","contentParent":"styles_contentParent__1i7Bq","header":"styles_header__1RYqq"};